import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@shared/components/icon';
import { AvatarComponent } from './avatar.component';

@NgModule({
  exports: [AvatarComponent],
  imports: [CommonModule, IconModule, AvatarComponent],
})
export class AvatarModule {}
